<template>
  <b-navbar-nav>
    <b-nav-item-dropdown right>
      <template slot="button-content">
        <i class="fa fa-user-circle fa-lg"></i>
      </template>
      <b-dropdown-header>{{currentUser.email}}</b-dropdown-header>
      <b-dropdown-item href="#" @click.prevent="$store.dispatch('signOut')">Sign out</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-navbar-nav>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState(["currentUser"])
  }
};
</script>
